import { TextLabel } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const ContaBancariaVisualizar = ({ contaDescricao, contaBancaria }) => {
  if (contaBancaria === null) {
    contaBancaria = {};
  }

  const { tipoConta, banco, agencia, contaDigito, numeroConta, agenciaDigito } = contaBancaria;

  return (
    <>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel id="conta.descricao" label="Descrição" value={contaDescricao} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          readOnly
          id="conta.contaBancaria.tipoConta"
          label="Tipo da conta"
          value={tipoConta}
          options={[
            { id: 'CORRENTE', title: 'Conta corrente' },
            { id: 'POUPANCA', title: 'Conta poupança' },
            { id: 'INVESTIMENTO', title: 'Conta investimento' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextLabel readOnly id="conta.contaBancaria.banco" label="Banco" value={banco && banco.nome} />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextLabel id="conta.contaBancaria.agencia" label="Agência" type="number" value={agencia} />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <TextLabel id="conta.contaBancaria.agenciaDigito" type="number" label="Dígito" value={agenciaDigito} />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <TextLabel id="conta.contaBancaria.numeroConta" label="Conta" type="number" value={numeroConta} />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <TextLabel id="conta.contaBancaria.contaDigito" label="Dígito" value={contaDigito} />
      </Grid>
    </>
  );
};

ContaBancariaVisualizar.propTypes = {
  contaDescricao: PropTypes.string,
  contaBancaria: PropTypes.shape({
    tipoConta: PropTypes.string,
    banco: PropTypes.string,
    agencia: PropTypes.string,
    agenciaDigito: PropTypes.string,
    numeroConta: PropTypes.string,
    contaDigito: PropTypes.string,
  }),
};

ContaBancariaVisualizar.defaultProps = {
  contaBancaria: {},
};

export default ContaBancariaVisualizar;
